var app = angular.module("leonardo");

var DynamicFormListActions = function($scope, $state, PermissionService, FolderService, ngDialog,
                                      FilterService, SectorRestService, AuthDataService, AccountUserService) {

  $scope.permissionService = PermissionService;
  $scope.account = AuthDataService.authData.account ? AuthDataService.authData.account.id : '';
  $scope.folders = [];
  $scope.accountObj = null;
  if($scope.account) {
    $scope.accountObj = AccountUserService.currentAccountUser;
  }

  $scope.getSector = function() {
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
      if(FilterService.hasFilter('sector')){
        return FilterService.getFilter('sector');
      }
      return ((SectorRestService.getCollection().length > 0) ? SectorRestService.getCollection()[0].id : null);
    }
    return null;
  };

  $scope.getFolder = function (account) {
    var folderObj = null;
    angular.forEach($scope.folders, function (folder) {
      if (folder.account == account)
        folderObj = folder;
    });
    return folderObj;
  };

  $scope.showFolderAddDialog = function() {
    ngDialog.open({
      template: 'views/templates/dialog/folder/add.html',
      controller: 'FolderAddDialog',
      data: {
        entity: FolderService.bulkObject($scope.account, $scope.getSector()),
        action: 'create',
        parent: $scope.getFolder($scope.account)
      }
    });
  };

  $scope.addForm = function(){
    var params = $state.params.pk ? {folder: $state.params.pk} : {folder: null};
    $state.go('documents.dynamic-forms.add', params);
  };

  $scope.showTagAddDialog = function() {
    ngDialog.openConfirm({
      controller: 'SystemTagAddDialog',
      templateUrl: 'views/templates/dialog/dynamic-form/system-tag-add.html',
      data: { mode: 'create'}
    })
  };
   
  $scope.exportTranslatedTemplates = function(){
    ngDialog.openConfirm({
      controller: 'ExportTranslatedDialog',
      templateUrl: 'views/templates/dialog/dynamic-form/export-translated-content.html',
      data: {languages: $scope.accountObj && $scope.accountObj.languages}
    })
  }

  $scope.$on('folders-dynamic:updated', function (event, folders) {
    $scope.folders = folders;
    $scope.folder = $scope.getFolder($scope.account);
  });

};

app.controller('DynamicFormListActions', ['$scope', '$state', 'PermissionService', 'FolderService', 'ngDialog',
  'FilterService', 'SectorRestService', 'AuthDataService', 'AccountUserService', DynamicFormListActions]);
